import React, { Component } from 'react'

import setup from '../../../module/setup'
import MyDashboard from '../../MyDashboard/MyDashboard'

export default class MyDashboardScene extends Component {
  render() {
    const { history } = this.props
    const goToWorkout = ({ questionBankId }) => {
      history.push(`/${setup.workout.path}${questionBankId}`)
    }
    return <MyDashboard goToWorkout={goToWorkout} />
  }
}



// WEBPACK FOOTER //
// ./src/component/_scenes/Scene/MyDashboard.jsx